import { getModalList } from "@/components/HBModal/ModalWrap";
import { SHORTCUT } from "@/constants/shortcut";
import useAppStore from "@/context/store";
import isEditingElement from "@/utils/isEditingElement";
import { useKeyPress } from "ahooks";
import scrollTo from "antd/lib/_util/scrollTo";
import { throttle } from "lodash";
import { useRouter } from "next/router";
import { useCallback } from "react";
import { openBoardModal, openCreatePin } from "../../utils/open";
import SuspensionPanelComponent from "./SuspensionPanel";

export default function SideButtonList() {
  const { headerHeight } = useAppStore(({ headerHeight, user, config }) => ({
    headerHeight,
    user,
    config,
  }));
  const router = useRouter();

  const onCreateBoard = useCallback(async () => {
    openBoardModal({
      name: "boardModal",
      onOk: (board) => {
        router.push(`/boards/${board.board_id}`);
      },
    });
  }, [router]);

  const onCreatePin = useCallback(async () => {
    openCreatePin();
  }, []);

  // 回到顶部
  useKeyPress(
    SHORTCUT.TO_TOP,
    () => {
      const editing = isEditingElement();
      if (editing) {
        return false;
      }

      // 判断是否打开采集详情弹窗，如果打开就滚动弹窗
      const pinModal = document.querySelector(".pinDetailModal");
      if (pinModal) {
        scrollTo(0, {
          getContainer: () => pinModal,
        });
      } else {
        scrollTo(0);
      }
    },
    {
      exactMatch: true,
    }
  );
  // 快捷键提示
  useKeyPress(
    SHORTCUT.SHORTCUT_TIP,
    async () => {
      const editing = isEditingElement();
      if (editing) {
        return false;
      }

      const modalList = getModalList();
      const modal = modalList.find((modal) => modal.name === "shortcutModal");
      if (modal) {
        modal.close();
      } else {
        const { default: ShortcutModal } = await import("../ShortcutModal");
        ShortcutModal.open({
          name: "shortcutModal",
        });
      }
    },
    {
      exactMatch: true,
    }
  );
  // 新建画板
  useKeyPress(
    SHORTCUT.CREATE_BOARD,
    () => {
      const editing = isEditingElement();
      if (editing) {
        return false;
      }
      const modalList = getModalList();
      const modal = modalList.find((modal) => modal.name === "boardModal");
      if (modal) {
        modal.close();
      } else {
        onCreateBoard();
      }
    },
    {
      exactMatch: true,
    }
  );
  // 上传采集
  useKeyPress(
    SHORTCUT.UPLOAD_PIN,
    () => {
      const editing = isEditingElement();
      if (editing) {
        return false;
      }

      const modalList = getModalList();
      const modal = modalList.find(
        (modal) => modal.name === "pinUploaderModal"
      );
      if (modal) {
        modal.close();
      } else {
        onCreatePin();
      }
    },
    {
      exactMatch: true,
    }
  );
  // 向下滚动
  useKeyPress(
    SHORTCUT.SCROLL_DOWN,
    throttle(
      () => {
        const editing = isEditingElement();
        if (editing) {
          return false;
        }
        // 判断是否打开采集详情弹窗，如果打开就滚动弹窗
        const pinModal = document.querySelector(".pinDetailModal");
        if (pinModal) {
          pinModal.scrollBy({
            top: window.innerHeight - headerHeight,
            behavior: "smooth",
          });
        } else {
          window.scrollBy({
            top: window.innerHeight - headerHeight,
            behavior: "smooth",
          });
        }
      },
      700,
      { trailing: false }
    ),
    {
      exactMatch: true,
    }
  );
  // 线上滚动
  useKeyPress(
    SHORTCUT.SCROLL_UP,
    throttle(
      () => {
        const editing = isEditingElement();
        if (editing) {
          return false;
        }
        // 判断是否打开采集详情弹窗，如果打开就滚动弹窗
        const pinModal = document.querySelector(".pinDetailModal");
        if (pinModal) {
          pinModal.scrollBy({
            top: headerHeight - window.innerHeight,
            behavior: "smooth",
          });
        } else {
          window.scrollBy({
            top: headerHeight - window.innerHeight,
            behavior: "smooth",
          });
        }
      },
      700,
      { trailing: false }
    ),
    {
      exactMatch: true,
    }
  );

  return (
    <>
      <SuspensionPanelComponent />
    </>
  );
}
